import * as Yup from "yup";

export const ForgotPasswordSchema = Yup.object({
  email: Yup.string().min(5,"login.block-form.error.username-min").required("login.block-form.error.username-required")
});
